import React from 'react'
import PropTypes from 'prop-types'

const AddSubscriber = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1271 13.0419V10.7283H13.8136V9.18597H16.1271V6.87244H17.6695V9.18597H19.983V10.7283H17.6695V13.0419H16.1271ZM9.18652 11.4995C8.33823 11.4995 7.61203 11.1975 7.00794 10.5934C6.40385 9.98929 6.10181 9.26309 6.10181 8.41479C6.10181 7.5665 6.40385 6.8403 7.00794 6.23621C7.61203 5.63212 8.33823 5.33008 9.18652 5.33008C10.0348 5.33008 10.761 5.63212 11.3651 6.23621C11.9692 6.8403 12.2712 7.5665 12.2712 8.41479C12.2712 9.26309 11.9692 9.98929 11.3651 10.5934C10.761 11.1975 10.0348 11.4995 9.18652 11.4995ZM3.01709 17.6689V15.5096C3.01709 15.0726 3.12955 14.671 3.35448 14.3047C3.57941 13.9384 3.87824 13.6588 4.25098 13.466C5.04786 13.0676 5.8576 12.7687 6.68019 12.5695C7.50278 12.3703 8.33823 12.2707 9.18652 12.2707C10.0348 12.2707 10.8703 12.3703 11.6929 12.5695C12.5154 12.7687 13.3252 13.0676 14.1221 13.466C14.4948 13.6588 14.7936 13.9384 15.0186 14.3047C15.2435 14.671 15.356 15.0726 15.356 15.5096V17.6689H3.01709ZM4.55945 16.1266H13.8136V15.5096C13.8136 15.3683 13.7783 15.2397 13.7076 15.1241C13.6369 15.0084 13.5437 14.9184 13.428 14.8541C12.7339 14.5071 12.0335 14.2468 11.3265 14.0733C10.6196 13.8998 9.90629 13.813 9.18652 13.813C8.46676 13.813 7.75342 13.8998 7.0465 14.0733C6.33959 14.2468 5.6391 14.5071 4.94504 14.8541C4.82936 14.9184 4.73618 15.0084 4.66549 15.1241C4.59479 15.2397 4.55945 15.3683 4.55945 15.5096V16.1266ZM9.18652 9.95715C9.61067 9.95715 9.97377 9.80613 10.2758 9.50409C10.5779 9.20204 10.7289 8.83894 10.7289 8.41479C10.7289 7.99065 10.5779 7.62755 10.2758 7.3255C9.97377 7.02346 9.61067 6.87244 9.18652 6.87244C8.76237 6.87244 8.39928 7.02346 8.09723 7.3255C7.79519 7.62755 7.64417 7.99065 7.64417 8.41479C7.64417 8.83894 7.79519 9.20204 8.09723 9.50409C8.39928 9.80613 8.76237 9.95715 9.18652 9.95715Z"
        fill={color}
      />
    </svg>
  )
}

AddSubscriber.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(AddSubscriber)
